import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { breakpoints } from '../../../utils/styles';

const Container = styled.div`
  height: 100%;
  user-select: none;
  width: 360px;

  @media (min-width: ${breakpoints.desktop}px) {
    aspect-ratio: 9 / 16;
    height: auto;
  }
`;

export const SlideContainer = ({ children }: { children: React.ReactNode }) => {
  return <Container >{children}</Container>;
};